import { GTM_CONTAINER_ID, shouldLoadGtm } from '@zealth/core/analytics/gtm'
import { isInIframe } from '@zealth/core/env/isInIframe'

import { getTargetEnv } from '@/config/targetEnv'

declare global {
  interface Window {
    dataLayer?: Record<string, unknown>[]
  }
}

const GTM_SCRIPT_URL = 'https://www.googletagmanager.com/gtm.js?id='

// Loads the Google Tag Manager container that the marketing site also runs,
// so zealth.io and portal.zealth.io report into one GA4 property.
export function initGtm(): void {
  // Same reasoning as initAnalytics — the playground embeds the portal in an
  // iframe, and those sessions would otherwise count as real traffic.
  if (isInIframe()) return

  if (!shouldLoadGtm(getTargetEnv())) return

  window.dataLayer = window.dataLayer ?? []
  window.dataLayer.push({ 'gtm.start': Date.now(), event: 'gtm.js' })

  const script = document.createElement('script')
  script.async = true
  script.src = `${GTM_SCRIPT_URL}${GTM_CONTAINER_ID}`
  document.head.appendChild(script)
}
